import React, { useState, useEffect } from "react"
import Play from "src/assets/play.png"
import Pause from "src/assets/pause.png"
import styled from "styled-components"
import Player from "react-player"
import Typography from "components/Typography"
import { useInView } from "react-intersection-observer"

const PlayerContainer = styled.div`
  display: grid;
  grid-template: auto / 10% 90%;
`

const PlayerButton = styled.button`
  background: black;
  background-image: ${({ playing }) =>
    playing ? `url(${Pause})` : `url(${Play})`};
  background-size: cover;
  height: 2rem;
  width: 2rem;
  border: none;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
`

const AudioPlayer = ({ src, description, style, inViewPlay = false }) => {
  const [isPlaying, setPlaying] = useState(false)

  const [ref, inView] = useInView({
    threshold: 1,
  })

  useEffect(() => {
    inViewPlay && !inView && setPlaying(false)
  }, [inView, inViewPlay])

  const togglePlaying = () => setPlaying(!isPlaying)
  if (!src.includes("http")) return null
  return (
    <>
      <Player url={src} playing={isPlaying} width={0} height={0} />
      <PlayerContainer ref={ref}>
        <PlayerButton onClick={togglePlaying} playing={isPlaying} />
        <Typography variant="modalText" style={style}>
          {description}
        </Typography>
      </PlayerContainer>
    </>
  )
}

export default AudioPlayer
